"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeApp = initializeApp;

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _actions = require("../../EpicMigration/actions");

var epicMigrationActions = _interopRequireWildcard(_actions);

var _user = require("./user");

var userActions = _interopRequireWildcard(_user);

var _auth = require("./auth");

var authActions = _interopRequireWildcard(_auth);

var _packs = require("./packs");

var _softwares = require("./softwares");

var _companyLogos = require("./companyLogos");

var _notifications = require("./notifications");

var _eol = require("./eol");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializeApp(_ref) {
  var location = _ref.location;
  var coupon = location.query.coupon;


  return function (dispatch) {
    var loadUser = dispatch(userActions.load()).then(function () {
      dispatch(authActions.validateEula());
      // Don't let refund eligibility failures break initialization
      dispatch(userActions.fetchPointsRefundEligibility()).catch(function (err) {
        console.log("[initializeApp] Refund eligibility check failed (non-fatal):", err);
      });
      if (coupon) return dispatch(userActions.redeemCodeAction(location));
    });

    return _bluebird2.default.all([dispatch((0, _packs.loadPacksPage)()), dispatch((0, _notifications.load)()), dispatch((0, _softwares.loadMixerUpdater)()), dispatch((0, _companyLogos.getLogos)()), dispatch(epicMigrationActions.recallIfWeRedirectedToEpicLoginAndCompleteLoginIfSo(location)), loadUser, dispatch((0, _eol.fetchEolConfig)())]);
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/app.js
// module id = 2878
// module chunks = 0